import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

/** The list's quick filters. No value means "All". */
export const RATE_CARD_QUICK_FILTER = {
	WITH_RATES: "with-rates",
	NEEDS_ATTENTION: "needs-attention",
} as const;
export type RateCardQuickFilter =
	(typeof RATE_CARD_QUICK_FILTER)[keyof typeof RATE_CARD_QUICK_FILTER];

export const rateCardsFilterSchema = z.object({
	search: optionalFilterString,
	show: z.nativeEnum(RATE_CARD_QUICK_FILTER).optional(),
});

/** The detail page's period filter. No value means "Valid now". */
export const RATE_PERIOD_FILTER = {
	UPCOMING: "upcoming",
	ALL: "all",
} as const;
export type RatePeriodFilter =
	(typeof RATE_PERIOD_FILTER)[keyof typeof RATE_PERIOD_FILTER];

export const rateCardDetailFilterSchema = z.object({
	search: optionalFilterString,
	period: z.nativeEnum(RATE_PERIOD_FILTER).optional(),
	/** Only the rates in an overlapping pair. */
	overlaps: z.boolean().optional(),
});
